(() => {
  if (window.tyvokFallSale2026) return;
  window.tyvokFallSale2026 = true;
  const savings = {51472725344548:8000,54012167913764:8000,51472725377316:10000,51472725410084:15000,47577250726180:10000,47523552756004:15000,47577283559716:20000,51298610610468:30000,54006101377316:100000};
  const start=Date.parse('2026-10-08T04:00:00Z'), end=Date.parse('2026-11-01T03:59:00Z');
  const active=()=>Date.now()>=start && Date.now()<end;
  const initialActive=active();
  window.tyvokFallSaleVariantPrice2026=v=>v.price-(active() && v.available ? (savings[v.id]||0) : 0);
  const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',minimumFractionDigits:2,maximumFractionDigits:2}).format(n/100);
  const put=(el,value)=>{if(el && el.textContent!==value)el.textContent=value};
  const option=(el,price,catalog)=>{
    if(!el)return;
    const text=money(price), old=money(catalog);
    if(el.dataset.salePrice===text && el.dataset.saleCatalog===old && el.querySelector('s'))return;
    const strike=document.createElement('s');strike.className='tyvok-option-catalog';strike.textContent=old;
    el.replaceChildren(document.createTextNode(text),strike);el.dataset.salePrice=text;el.dataset.saleCatalog=old;
  };
  class FallSaleCoupon extends HTMLElement {
    connectedCallback(){
      this.variants=JSON.parse(this.querySelector('[data-sale-variants]').textContent);
      this.scope=this.closest('.shopify-section') || this.parentElement;
      this.update=()=>{
        const id=this.scope.querySelector('[data-p2-variant-id]')?.value || this.scope.querySelector('form[action*="/cart/add"] [name="id"]')?.value || new URLSearchParams(location.search).get('variant') || this.variants.find(v=>v.available)?.id;
        const v=this.variants.find(v=>String(v.id)===String(id));
        this.hidden=!(active() && v?.available && savings[id]);
        if(this.hidden)return;
        const isP2=!!this.scope.querySelector('[data-p2-variant]');
        const saving=amount=>(this.dataset.saveTemplate || 'Save __AMOUNT__').replace('__AMOUNT__',money(amount))+(isP2?' total':'');
        this.variants.forEach(item=>{
          const amount=savings[item.id]||0;if(!amount)return;
          const price=item.price-amount,catalog=item.compare_at_price||item.price;
          const radio=this.scope.querySelector(`[data-p2-variant][value="${item.id}"]`);
          if(radio){radio.dataset.price=money(price);radio.dataset.priceCents=price;radio.dataset.saving=saving(catalog-price);radio.dataset.automaticDiscount=amount;radio.dataset.automaticDiscountMoney=money(amount);option(radio.closest('label')?.querySelector('.p2-conversion__variant-price'),price,catalog)}
          this.scope.querySelectorAll('input[type="radio"]').forEach(input=>{
            if(input.value!==item.title || !input.id)return;
            const label=this.scope.querySelector(`label[for="${CSS.escape(input.id)}"]`);
            option(label?.querySelector('.x1s-qb-price'),price,catalog);
          });
        });
        const price=v.price-savings[v.id],catalog=v.compare_at_price||v.price;
        put(this.scope.querySelector('[data-p2-price]'),money(price));
        put(this.scope.querySelector('[data-p2-saving]'),saving(catalog-price));
        put(this.scope.querySelector('[data-p2-automatic-discount]'),'Includes '+money(savings[v.id])+' automatic Fall Sale discount');
        put(this.scope.querySelector('[data-p2-sticky-price]'),money(price));
      };
      this.update();this.timer=setInterval(()=>{if(!document.hidden)this.update()},250);
    }
    disconnectedCallback(){clearInterval(this.timer)}
  }
  if(!customElements.get('tyvok-fall-coupon'))customElements.define('tyvok-fall-coupon',FallSaleCoupon);
  const update=()=>{
    if(active()!==initialActive){location.reload();return}
    document.querySelectorAll('[data-sale-banner]').forEach(el=>el.hidden=!active());
    if(!active())return;
    document.querySelectorAll('[data-tyvok-sale-variant]').forEach(el=>{
      if(el.closest('.product-information'))return;
      const amount=savings[el.dataset.tyvokSaleVariant];if(!amount)return;
      const price=Number(el.dataset.retailCents)-amount,catalog=Number(el.dataset.catalogCents);
      put(el.querySelector('ins .amount'),(el.dataset.saleFrom==='true'?'From ':'')+money(price)+(el.dataset.saleCurrencyCode==='true'?' USD':''));
      const type=el.dataset.saleBadgeType;
      if(type==='save_amount'||type==='save_percentage'){
        const saved=type==='save_percentage'?Math.round((catalog-price)*100/catalog)+'%':money(catalog-price);
        el.querySelectorAll('.badge.onsale').forEach(badge=>{
          const value=el.dataset.saleSaveTemplate.replace('__AMOUNT__',saved);
          if(badge.innerHTML!==value)badge.innerHTML=value;
        });
      }
    });
  };
  update();setInterval(update,1000);
})();
